module.exports = __webpack_public_path__ + "static/ticketbase-screencast-6d6bf7300b6fc40e8b617e638dff55df.mp4";